import React from 'react';
import {AutoComplete} from 'antd';

import {FormFieldInputWrapperClasses, FormFieldWrapperClasses} from '../';
import {trb} from '../../../Utilities';

export const AutocompleteFormField = (props) => {
    const title = props.title,
        titleWithoutTranslate = props.titleWithoutTranslate,
        className = props.className,
        inline = props.inline,
        placeholder = props.placeholder,
        disabled = props.disabled,
        options = props.options,
        onSelect = props.onSelect,
        onSearch = props.onSearch;

    const meta = props.meta;

    return <div className={FormFieldWrapperClasses(className, inline)}>
        {title && <div className={inline ? 'form-field-title col-12 col-md-3 text-left text-md-right pb-2 pb-md-0' : 'form-field-title col-12'}>{titleWithoutTranslate ? title : trb(title)}</div>}
        <div className={FormFieldInputWrapperClasses(meta.error, meta.submitError, meta.touched, inline)}>
            <AutoComplete
                allowClear
                autoComplete="none"
                autoCorrect="off"
                autoCapitalize="none"
                spellCheck="off"
                dataSource={options}
                placeholder={trb(placeholder)}
                disabled={disabled}
                name={props.input.name}
                value={props.input.value}
                onChange={props.input.onChange}
                onSelect={onSelect}
                onSearch={onSearch}
                getPopupContainer={() => document.getElementById('card')}
            />
        </div>
        <div className={inline ? 'form-field-error col-3' : 'form-field-error'}>{meta.touched && (meta.error || meta.submitError)}</div>
    </div>
};
